import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[40rem] h-full mx-auto flex flex-col justify-center items-center gap-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-3xl text-center" }, [
  /*#__PURE__*/_createTextVNode("Oof, the page you’re looking for doesn’t exist but hey - "),
  /*#__PURE__*/_createElementVNode("span", { class: "block" }, "you found our dog!")
], -1)
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = ["src"]

import ErrorImage from "@/assets/images/404Error.svg"

export default /*#__PURE__*/_defineComponent({
  __name: '404Page',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", { src: _unref(ErrorImage) }, null, 8, _hoisted_4)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})